'use client';

import { usePathname } from 'next/navigation';
import { FaCircleArrowRight } from 'react-icons/fa6';

import { LinkButton } from '@ui/link-button';

export default function ButtonComparer() {
  const pathname = usePathname();

  return (
    <LinkButton
      href="/devis"
      display={{
        md: 'none',
      }}
      position="fixed"
      bottom="2"
      right="2"
      zIndex="sticky"
      size={{
        base: 'md',
        sm: 'lg',
      }}
      hideBelow={pathname === '/' ? 'md' : undefined}
      css={{
        '@media print': {
          display: 'none',
        },
      }}
    >
      Comparer maintenant
      <FaCircleArrowRight />
    </LinkButton>
  );
}
